/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

export default [
  {
    path: '/multi-sign-in',
    name: 'auth.multiple.sign.in',
    component: () => import('@/views/Auth/MultipleSignIn.vue'),
    meta: {
      guest: true,
      app: 'auth',
    },
  },

  {
    path: '/sign-in',
    name: 'auth.sign.in',
    component: () => import('@/views/Auth/SignIn.vue'),
    meta: {
      guest: true,
      app: 'auth',
    },
  },

  {
    path: '/register',
    name: 'auth.register',
    component: () => import('@/views/Auth/Register.vue'),
    meta: {
      guest: true,
      app: 'auth',
    },
  },

  {
    path: '/request-verification-link',
    name: 'auth.request.verification.link',
    component: () => import('@/views/Auth/RequestVerificationLink.vue'),
    meta: {
      auth: true,
      app: 'auth',
    },
  },

  {
    path: '/request-reset-password',
    name: 'auth.request.reset.password',
    component: () => import('@/views/Auth/RequestResetPassword.vue'),
    meta: {
      guest: true,
      app: 'auth',
    },
  },

  {
    path: '/reset-password',
    name: 'auth.reset.password',
    component: () => import('@/views/Auth/ResetPassword.vue'),
    meta: {
      guest: true,
      app: 'auth',
    },
  },

  {
    path: '/magic-link-registration',
    name: 'auth.magic.link.registration',
    component: () => import('@/views/Auth/MagicLinkRegistration.vue'),
    meta: {
      guest: true,
      app: 'auth',
    },
  },

  {
    path: '/verify-email',
    name: 'auth.verify.email',
    component: () => import('@/views/Auth/VerifyEmail.vue'),
    meta: {
      app: 'auth',
    },
  },

  {
    path: '/not-found',
    name: 'general.not.found',
    component: () => import('@/views/General/NotFound.vue'),
    meta: {
    },
  },

  {
    path: '/mail-sends',
    name: 'admin.send.magic.links',
    component: () => import('@/views/Admin/MailSends.vue'),
    meta: {
      auth: true,
      admin: true,
      app: 'emails',
    },
  },

  {
    path: '/email-changed',
    name: 'general.email.changed',
    component: () => import('@/views/General/MailChanged.vue'),
    meta: {
    },
  },
];
